import { LinearProgress } from '@mui/material';
import React from 'react';
import { Modal } from '../../../components';
import { useSelector } from '../../../stores';

export const SaleIrregularitiesReceiptExportModal: React.FC = () => {
  const {
    saleIrregularitiesReceiptExportPercentage,
    saleIrregularitiesReceiptExportModalIsOpen,
  } = useSelector((state) => state.saleReducer);

  return (
    <Modal
      open={saleIrregularitiesReceiptExportModalIsOpen}
      onClose={() => {}}
      title='Preparando exportação dos recibos'
      noCloseButton
    >
      <LinearProgress
        variant='determinate'
        value={saleIrregularitiesReceiptExportPercentage}
        sx={{ height: '20px', borderRadius: '40px' }}
      />
    </Modal>
  );
};
